module.exports = __webpack_public_path__ + "img/payment-with-card-dark.55434192.svg";